import { render, staticRenderFns } from "./MyClass.vue?vue&type=template&id=e78ca12e&scoped=true"
import script from "./MyClass.vue?vue&type=script&lang=js"
export * from "./MyClass.vue?vue&type=script&lang=js"
import style0 from "./MyClass.vue?vue&type=style&index=0&id=e78ca12e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78ca12e",
  null
  
)

export default component.exports